
; /*!
 * perfect-scrollbar v1.5.3
 * Copyright 2021 Hyunje Jun, MDBootstrap and Contributors
 * Licensed under MIT
 */

(function (global, factory) {
    typeof exports === 'object' && typeof module !== 'undefined' ? module.exports = factory() :
        typeof define === 'function' && define.amd ? define(factory) :
            (global = global || self, global.PerfectScrollbar = factory());
}(this, (function () { 'use strict';

    function get(element) {
        return getComputedStyle(element);
    }

    function set(element, obj) {
        for (var key in obj) {
            var val = obj[key];
            if (typeof val === 'number') {
                val = val + "px";
            }
            element.style[key] = val;
        }
        return element;
    }

    function div(className) {
        var div = document.createElement('div');
        div.className = className;
        return div;
    }

    var elMatches =
        typeof Element !== 'undefined' &&
        (Element.prototype.matches ||
            Element.prototype.webkitMatchesSelector ||
            Element.prototype.mozMatchesSelector ||
            Element.prototype.msMatchesSelector);

    function matches(element, query) {
        if (!elMatches) {
            throw new Error('No element matching method supported');
        }

        return elMatches.call(element, query);
    }

    function remove(element) {
        if (element.remove) {
            element.remove();
        } else {
            if (element.parentNode) {
                element.parentNode.removeChild(element);
            }
        }
    }

    function queryChildren(element, selector) {
        return Array.prototype.filter.call(element.children, function (child) { return matches(child, selector); }
        );
    }

    var cls = {
        main: 'ps',
        rtl: 'ps__rtl',
        element: {
            thumb: function (x) { return ("ps__thumb-" + x); },
            rail: function (x) { return ("ps__rail-" + x); },
            consuming: 'ps__child--consume',
        },
        state: {
            focus: 'ps--focus',
            clicking: 'ps--clicking',
            active: function (x) { return ("ps--active-" + x); },
            scrolling: function (x) { return ("ps--scrolling-" + x); },
        },
    };

    /*
     * Helper methods
     */
    var scrollingClassTimeout = { x: null, y: null };

    function addScrollingClass(i, x) {
        var classList = i.element.classList;
        var className = cls.state.scrolling(x);

        if (classList.contains(className)) {
            clearTimeout(scrollingClassTimeout[x]);
        } else {
            classList.add(className);
        }
    }

    function removeScrollingClass(i, x) {
        scrollingClassTimeout[x] = setTimeout(
            function () { return i.isAlive && i.element.classList.remove(cls.state.scrolling(x)); },
            i.settings.scrollingThreshold
        );
    }

    function setScrollingClassInstantly(i, x) {
        addScrollingClass(i, x);
        removeScrollingClass(i, x);
    }

    var EventElement = function EventElement(element) {
        this.element = element;
        this.handlers = {};
    };

    var prototypeAccessors = { isEmpty: { configurable: true } };

    EventElement.prototype.bind = function bind (eventName, handler) {
        if (typeof this.handlers[eventName] === 'undefined') {
            this.handlers[eventName] = [];
        }
        this.handlers[eventName].push(handler);
        this.element.addEventListener(eventName, handler, false);
    };

    EventElement.prototype.unbind = function unbind (eventName, target) {
        var this$1 = this;

        this.handlers[eventName] = this.handlers[eventName].filter(function (handler) {
            if (target && handler !== target) {
                return true;
            }
            this$1.element.removeEventListener(eventName, handler, false);
            return false;
        });
    };

    EventElement.prototype.unbindAll = function unbindAll () {
        for (var name in this.handlers) {
            this.unbind(name);
        }
    };

    prototypeAccessors.isEmpty.get = function () {
        var this$1 = this;

        return Object.keys(this.handlers).every(
            function (key) { return this$1.handlers[key].length === 0; }
        );
    };

    Object.defineProperties( EventElement.prototype, prototypeAccessors );

    var EventManager = function EventManager() {
        this.eventElements = [];
    };

    EventManager.prototype.eventElement = function eventElement (element) {
        var ee = this.eventElements.filter(function (ee) { return ee.element === element; })[0];
        if (!ee) {
            ee = new EventElement(element);
            this.eventElements.push(ee);
        }
        return ee;
    };

    EventManager.prototype.bind = function bind (element, eventName, handler) {
        this.eventElement(element).bind(eventName, handler);
    };

    EventManager.prototype.unbind = function unbind (element, eventName, handler) {
        var ee = this.eventElement(element);
        ee.unbind(eventName, handler);

        if (ee.isEmpty) {
            // remove
            this.eventElements.splice(this.eventElements.indexOf(ee), 1);
        }
    };

    EventManager.prototype.unbindAll = function unbindAll () {
        this.eventElements.forEach(function (e) { return e.unbindAll(); });
        this.eventElements = [];
    };

    EventManager.prototype.once = function once (element, eventName, handler) {
        var ee = this.eventElement(element);
        var onceHandler = function (evt) {
            ee.unbind(eventName, onceHandler);
            handler(evt);
        };
        ee.bind(eventName, onceHandler);
    };

    function createEvent(name) {
        if (typeof window.CustomEvent === 'function') {
            return new CustomEvent(name);
        } else {
            var evt = document.createEvent('CustomEvent');
            evt.initCustomEvent(name, false, false, undefined);
            return evt;
        }
    }

    function processScrollDiff(
        i,
        axis,
        diff,
        useScrollingClass,
        forceFireReachEvent
    ) {
        if ( useScrollingClass === void 0 ) useScrollingClass = true;
        if ( forceFireReachEvent === void 0 ) forceFireReachEvent = false;

        var fields;
        if (axis === 'top') {
            fields = [
                'contentHeight',
                'containerHeight',
                'scrollTop',
                'y',
                'up',
                'down' ];
        } else if (axis === 'left') {
            fields = [
                'contentWidth',
                'containerWidth',
                'scrollLeft',
                'x',
                'left',
                'right' ];
        } else {
            throw new Error('A proper axis should be provided');
        }

        processScrollDiff$1(i, diff, fields, useScrollingClass, forceFireReachEvent);
    }

    function processScrollDiff$1(
        i,
        diff,
        ref,
        useScrollingClass,
        forceFireReachEvent
    ) {
        var contentHeight = ref[0];
        var containerHeight = ref[1];
        var scrollTop = ref[2];
        var y = ref[3];
        var up = ref[4];
        var down = ref[5];
        if ( useScrollingClass === void 0 ) useScrollingClass = true;
        if ( forceFireReachEvent === void 0 ) forceFireReachEvent = false;

        var element = i.element;

        // reset reach
        i.reach[y] = null;

        // 1 for subpixel rounding
        if (element[scrollTop] < 1) {
            i.reach[y] = 'start';
        }

        // 1 for subpixel rounding
        if (element[scrollTop] > i[contentHeight] - i[containerHeight] - 1) {
            i.reach[y] = 'end';
        }

        if (diff) {
            element.dispatchEvent(createEvent(("ps-scroll-" + y)));

            if (diff < 0) {
                element.dispatchEvent(createEvent(("ps-scroll-" + up)));
            } else if (diff > 0) {
                element.dispatchEvent(createEvent(("ps-scroll-" + down)));
            }

            if (useScrollingClass) {
                setScrollingClassInstantly(i, y);
            }
        }

        if (i.reach[y] && (diff || forceFireReachEvent)) {
            element.dispatchEvent(createEvent(("ps-" + y + "-reach-" + (i.reach[y]))));
        }
    }

    function toInt(x) {
        return parseInt(x, 10) || 0;
    }

    function isEditable(el) {
        return (
            matches(el, 'input,[contenteditable]') ||
            matches(el, 'select,[contenteditable]') ||
            matches(el, 'textarea,[contenteditable]') ||
            matches(el, 'button,[contenteditable]')
        );
    }

    function outerWidth(element) {
        var styles = get(element);
        return (
            toInt(styles.width) +
            toInt(styles.paddingLeft) +
            toInt(styles.paddingRight) +
            toInt(styles.borderLeftWidth) +
            toInt(styles.borderRightWidth)
        );
    }

    var env = {
        isWebKit:
            typeof document !== 'undefined' &&
            'WebkitAppearance' in document.documentElement.style,
        supportsTouch:
            typeof window !== 'undefined' &&
            ('ontouchstart' in window ||
                ('maxTouchPoints' in window.navigator &&
                    window.navigator.maxTouchPoints > 0) ||
                (window.DocumentTouch && document instanceof window.DocumentTouch)),
        supportsIePointer:
            typeof navigator !== 'undefined' && navigator.msMaxTouchPoints,
        isChrome:
            typeof navigator !== 'undefined' &&
            /Chrome/i.test(navigator && navigator.userAgent),
    };

    function updateGeometry(i) {
        var element = i.element;
        var roundedScrollTop = Math.floor(element.scrollTop);
        var rect = element.getBoundingClientRect();

        i.containerWidth = Math.round(rect.width);
        i.containerHeight = Math.round(rect.height);

        i.contentWidth = element.scrollWidth;
        i.contentHeight = element.scrollHeight;

        if (!element.contains(i.scrollbarXRail)) {
            // clean up and append
            queryChildren(element, cls.element.rail('x')).forEach(function (el) { return remove(el); }
            );
            element.appendChild(i.scrollbarXRail);
        }
        if (!element.contains(i.scrollbarYRail)) {
            // clean up and append
            queryChildren(element, cls.element.rail('y')).forEach(function (el) { return remove(el); }
            );
            element.appendChild(i.scrollbarYRail);
        }

        if (
            !i.settings.suppressScrollX &&
            i.containerWidth + i.settings.scrollXMarginOffset < i.contentWidth
        ) {
            i.scrollbarXActive = true;
            i.railXWidth = i.containerWidth - i.railXMarginWidth;
            i.railXRatio = i.containerWidth / i.railXWidth;
            i.scrollbarXWidth = getThumbSize(
                i,
                toInt((i.railXWidth * i.containerWidth) / i.contentWidth)
            );
            i.scrollbarXLeft = toInt(
                ((i.negativeScrollAdjustment + element.scrollLeft) *
                    (i.railXWidth - i.scrollbarXWidth)) /
                (i.contentWidth - i.containerWidth)
            );
        } else {
            i.scrollbarXActive = false;
        }

        if (
            !i.settings.suppressScrollY &&
            i.containerHeight + i.settings.scrollYMarginOffset < i.contentHeight
        ) {
            i.scrollbarYActive = true;
            i.railYHeight = i.containerHeight - i.railYMarginHeight;
            i.railYRatio = i.containerHeight / i.railYHeight;
            i.scrollbarYHeight = getThumbSize(
                i,
                toInt((i.railYHeight * i.containerHeight) / i.contentHeight)
            );
            i.scrollbarYTop = toInt(
                (roundedScrollTop * (i.railYHeight - i.scrollbarYHeight)) /
                (i.contentHeight - i.containerHeight)
            );
        } else {
            i.scrollbarYActive = false;
        }

        if (i.scrollbarXLeft >= i.railXWidth - i.scrollbarXWidth) {
            i.scrollbarXLeft = i.railXWidth - i.scrollbarXWidth;
        }
        if (i.scrollbarYTop >= i.railYHeight - i.scrollbarYHeight) {
            i.scrollbarYTop = i.railYHeight - i.scrollbarYHeight;
        }

        updateCss(element, i);

        if (i.scrollbarXActive) {
            element.classList.add(cls.state.active('x'));
        } else {
            element.classList.remove(cls.state.active('x'));
            i.scrollbarXWidth = 0;
            i.scrollbarXLeft = 0;
            element.scrollLeft = i.isRtl === true ? i.contentWidth : 0;
        }
        if (i.scrollbarYActive) {
            element.classList.add(cls.state.active('y'));
        } else {
            element.classList.remove(cls.state.active('y'));
            i.scrollbarYHeight = 0;
            i.scrollbarYTop = 0;
            element.scrollTop = 0;
        }
    }

    function getThumbSize(i, thumbSize) {
        if (i.settings.minScrollbarLength) {
            thumbSize = Math.max(thumbSize, i.settings.minScrollbarLength);
        }
        if (i.settings.maxScrollbarLength) {
            thumbSize = Math.min(thumbSize, i.settings.maxScrollbarLength);
        }
        return thumbSize;
    }

    function updateCss(element, i) {
        var xRailOffset = { width: i.railXWidth };
        var roundedScrollTop = Math.floor(element.scrollTop);

        if (i.isRtl) {
            xRailOffset.left =
                i.negativeScrollAdjustment +
                element.scrollLeft +
                i.containerWidth -
                i.contentWidth;
        } else {
            xRailOffset.left = element.scrollLeft;
        }
        if (i.isScrollbarXUsingBottom) {
            xRailOffset.bottom = i.scrollbarXBottom - roundedScrollTop;
        } else {
            xRailOffset.top = i.scrollbarXTop + roundedScrollTop;
        }
        set(i.scrollbarXRail, xRailOffset);

        var yRailOffset = { top: roundedScrollTop, height: i.railYHeight };
        if (i.isScrollbarYUsingRight) {
            if (i.isRtl) {
                yRailOffset.right =
                    i.contentWidth -
                    (i.negativeScrollAdjustment + element.scrollLeft) -
                    i.scrollbarYRight -
                    i.scrollbarYOuterWidth -
                    9;
            } else {
                yRailOffset.right = i.scrollbarYRight - element.scrollLeft;
            }
        } else {
            if (i.isRtl) {
                yRailOffset.left =
                    i.negativeScrollAdjustment +
                    element.scrollLeft +
                    i.containerWidth * 2 -
                    i.contentWidth -
                    i.scrollbarYLeft -
                    i.scrollbarYOuterWidth;
            } else {
                yRailOffset.left = i.scrollbarYLeft + element.scrollLeft;
            }
        }
        set(i.scrollbarYRail, yRailOffset);

        set(i.scrollbarX, {
            left: i.scrollbarXLeft,
            width: i.scrollbarXWidth - i.railBorderXWidth,
        });
        set(i.scrollbarY, {
            top: i.scrollbarYTop,
            height: i.scrollbarYHeight - i.railBorderYWidth,
        });
    }

    function clickRail(i) {
        var element = i.element;

        i.event.bind(i.scrollbarY, 'mousedown', function (e) { return e.stopPropagation(); });
        i.event.bind(i.scrollbarYRail, 'mousedown', function (e) {
            var positionTop =
                e.pageY -
                window.pageYOffset -
                i.scrollbarYRail.getBoundingClientRect().top;
            var direction = positionTop > i.scrollbarYTop ? 1 : -1;

            i.element.scrollTop += direction * i.containerHeight;
            updateGeometry(i);

            e.stopPropagation();
        });

        i.event.bind(i.scrollbarX, 'mousedown', function (e) { return e.stopPropagation(); });
        i.event.bind(i.scrollbarXRail, 'mousedown', function (e) {
            var positionLeft =
                e.pageX -
                window.pageXOffset -
                i.scrollbarXRail.getBoundingClientRect().left;
            var direction = positionLeft > i.scrollbarXLeft ? 1 : -1;

            i.element.scrollLeft += direction * i.containerWidth;
            updateGeometry(i);

            e.stopPropagation();
        });
    }

    function dragThumb(i) {
        bindMouseScrollHandler(i, [
            'containerWidth',
            'contentWidth',
            'pageX',
            'railXWidth',
            'scrollbarX',
            'scrollbarXWidth',
            'scrollLeft',
            'x',
            'scrollbarXRail' ]);
        bindMouseScrollHandler(i, [
            'containerHeight',
            'contentHeight',
            'pageY',
            'railYHeight',
            'scrollbarY',
            'scrollbarYHeight',
            'scrollTop',
            'y',
            'scrollbarYRail' ]);
    }

    function bindMouseScrollHandler(
        i,
        ref
    ) {
        var containerHeight = ref[0];
        var contentHeight = ref[1];
        var pageY = ref[2];
        var railYHeight = ref[3];
        var scrollbarY = ref[4];
        var scrollbarYHeight = ref[5];
        var scrollTop = ref[6];
        var y = ref[7];
        var scrollbarYRail = ref[8];

        var element = i.element;

        var startingScrollTop = null;
        var startingMousePageY = null;
        var scrollBy = null;

        function mouseMoveHandler(e) {
            if (e.touches && e.touches[0]) {
                e[pageY] = e.touches[0].pageY;
            }
            element[scrollTop] =
                startingScrollTop + scrollBy * (e[pageY] - startingMousePageY);
            addScrollingClass(i, y);
            updateGeometry(i);

            e.stopPropagation();
            if (e.type.startsWith('touch') && e.changedTouches.length > 1) {
                e.preventDefault();
            }
        }

        function mouseUpHandler() {
            removeScrollingClass(i, y);
            i[scrollbarYRail].classList.remove(cls.state.clicking);
            i.event.unbind(i.ownerDocument, 'mousemove', mouseMoveHandler);
        }

        function bindMoves(e, touchMode) {
            startingScrollTop = element[scrollTop];
            if (touchMode && e.touches) {
                e[pageY] = e.touches[0].pageY;
            }
            startingMousePageY = e[pageY];
            scrollBy =
                (i[contentHeight] - i[containerHeight]) /
                (i[railYHeight] - i[scrollbarYHeight]);
            if (!touchMode) {
                i.event.bind(i.ownerDocument, 'mousemove', mouseMoveHandler);
                i.event.once(i.ownerDocument, 'mouseup', mouseUpHandler);
                e.preventDefault();
            } else {
                i.event.bind(i.ownerDocument, 'touchmove', mouseMoveHandler);
            }

            i[scrollbarYRail].classList.add(cls.state.clicking);

            e.stopPropagation();
        }

        i.event.bind(i[scrollbarY], 'mousedown', function (e) {
            bindMoves(e);
        });
        i.event.bind(i[scrollbarY], 'touchstart', function (e) {
            bindMoves(e, true);
        });
    }

    function keyboard(i) {
        var element = i.element;

        var elementHovered = function () { return matches(element, ':hover'); };
        var scrollbarFocused = function () { return matches(i.scrollbarX, ':focus') || matches(i.scrollbarY, ':focus'); };

        function shouldPreventDefault(deltaX, deltaY) {
            var scrollTop = Math.floor(element.scrollTop);
            if (deltaX === 0) {
                if (!i.scrollbarYActive) {
                    return false;
                }
                if (
                    (scrollTop === 0 && deltaY > 0) ||
                    (scrollTop >= i.contentHeight - i.containerHeight && deltaY < 0)
                ) {
                    return !i.settings.wheelPropagation;
                }
            }

            var scrollLeft = element.scrollLeft;
            if (deltaY === 0) {
                if (!i.scrollbarXActive) {
                    return false;
                }
                if (
                    (scrollLeft === 0 && deltaX < 0) ||
                    (scrollLeft >= i.contentWidth - i.containerWidth && deltaX > 0)
                ) {
                    return !i.settings.wheelPropagation;
                }
            }
            return true;
        }

        i.event.bind(i.ownerDocument, 'keydown', function (e) {
            if (
                (e.isDefaultPrevented && e.isDefaultPrevented()) ||
                e.defaultPrevented
            ) {
                return;
            }

            if (!elementHovered() && !scrollbarFocused()) {
                return;
            }

            var activeElement = document.activeElement
                ? document.activeElement
                : i.ownerDocument.activeElement;
            if (activeElement) {
                if (activeElement.tagName === 'IFRAME') {
                    activeElement = activeElement.contentDocument.activeElement;
                } else {
                    // go deeper if element is a webcomponent
                    while (activeElement.shadowRoot) {
                        activeElement = activeElement.shadowRoot.activeElement;
                    }
                }
                if (isEditable(activeElement)) {
                    return;
                }
            }

            var deltaX = 0;
            var deltaY = 0;

            switch (e.which) {
                case 37: // left
                    if (e.metaKey) {
                        deltaX = -i.contentWidth;
                    } else if (e.altKey) {
                        deltaX = -i.containerWidth;
                    } else {
                        deltaX = -30;
                    }
                    break;
                case 38: // up
                    if (e.metaKey) {
                        deltaY = i.contentHeight;
                    } else if (e.altKey) {
                        deltaY = i.containerHeight;
                    } else {
                        deltaY = 30;
                    }
                    break;
                case 39: // right
                    if (e.metaKey) {
                        deltaX = i.contentWidth;
                    } else if (e.altKey) {
                        deltaX = i.containerWidth;
                    } else {
                        deltaX = 30;
                    }
                    break;
                case 40: // down
                    if (e.metaKey) {
                        deltaY = -i.contentHeight;
                    } else if (e.altKey) {
                        deltaY = -i.containerHeight;
                    } else {
                        deltaY = -30;
                    }
                    break;
                case 32: // space bar
                    if (e.shiftKey) {
                        deltaY = i.containerHeight;
                    } else {
                        deltaY = -i.containerHeight;
                    }
                    break;
                case 33: // page up
                    deltaY = i.containerHeight;
                    break;
                case 34: // page down
                    deltaY = -i.containerHeight;
                    break;
                case 36: // home
                    deltaY = i.contentHeight;
                    break;
                case 35: // end
                    deltaY = -i.contentHeight;
                    break;
                default:
                    return;
            }

            if (i.settings.suppressScrollX && deltaX !== 0) {
                return;
            }
            if (i.settings.suppressScrollY && deltaY !== 0) {
                return;
            }

            element.scrollTop -= deltaY;
            element.scrollLeft += deltaX;
            updateGeometry(i);

            if (shouldPreventDefault(deltaX, deltaY)) {
                e.preventDefault();
            }
        });
    }

    function wheel(i) {
        var element = i.element;

        function shouldPreventDefault(deltaX, deltaY) {
            var roundedScrollTop = Math.floor(element.scrollTop);
            var isTop = element.scrollTop === 0;
            var isBottom =
                roundedScrollTop + element.offsetHeight === element.scrollHeight;
            var isLeft = element.scrollLeft === 0;
            var isRight =
                element.scrollLeft + element.offsetWidth === element.scrollWidth;

            var hitsBound;

            // pick axis with primary direction
            if (Math.abs(deltaY) > Math.abs(deltaX)) {
                hitsBound = isTop || isBottom;
            } else {
                hitsBound = isLeft || isRight;
            }

            return hitsBound ? !i.settings.wheelPropagation : true;
        }

        function getDeltaFromEvent(e) {
            var deltaX = e.deltaX;
            var deltaY = -1 * e.deltaY;

            if (typeof deltaX === 'undefined' || typeof deltaY === 'undefined') {
                // OS X Safari
                deltaX = (-1 * e.wheelDeltaX) / 6;
                deltaY = e.wheelDeltaY / 6;
            }

            if (e.deltaMode && e.deltaMode === 1) {
                // Firefox in deltaMode 1: Line scrolling
                deltaX *= 10;
                deltaY *= 10;
            }

            if (deltaX !== deltaX && deltaY !== deltaY /* NaN checks */) {
                // IE in some mouse drivers
                deltaX = 0;
                deltaY = e.wheelDelta;
            }

            if (e.shiftKey) {
                // reverse axis with shift key
                return [-deltaY, -deltaX];
            }
            return [deltaX, deltaY];
        }

        function shouldBeConsumedByChild(target, deltaX, deltaY) {
            // FIXME: this is a workaround for <select> issue in FF and IE #571
            if (!env.isWebKit && element.querySelector('select:focus')) {
                return true;
            }

            if (!element.contains(target)) {
                return false;
            }

            var cursor = target;

            while (cursor && cursor !== element) {
                if (cursor.classList.contains(cls.element.consuming)) {
                    return true;
                }

                var style = get(cursor);

                // if deltaY && vertical scrollable
                if (deltaY && style.overflowY.match(/(scroll|auto)/)) {
                    var maxScrollTop = cursor.scrollHeight - cursor.clientHeight;
                    if (maxScrollTop > 0) {
                        if (
                            (cursor.scrollTop > 0 && deltaY < 0) ||
                            (cursor.scrollTop < maxScrollTop && deltaY > 0)
                        ) {
                            return true;
                        }
                    }
                }
                // if deltaX && horizontal scrollable
                if (deltaX && style.overflowX.match(/(scroll|auto)/)) {
                    var maxScrollLeft = cursor.scrollWidth - cursor.clientWidth;
                    if (maxScrollLeft > 0) {
                        if (
                            (cursor.scrollLeft > 0 && deltaX < 0) ||
                            (cursor.scrollLeft < maxScrollLeft && deltaX > 0)
                        ) {
                            return true;
                        }
                    }
                }

                cursor = cursor.parentNode;
            }

            return false;
        }

        function mousewheelHandler(e) {
            var ref = getDeltaFromEvent(e);
            var deltaX = ref[0];
            var deltaY = ref[1];

            if (shouldBeConsumedByChild(e.target, deltaX, deltaY)) {
                return;
            }

            var shouldPrevent = false;
            if (!i.settings.useBothWheelAxes) {
                // deltaX will only be used for horizontal scrolling and deltaY will
                // only be used for vertical scrolling - this is the default
                element.scrollTop -= deltaY * i.settings.wheelSpeed;
                element.scrollLeft += deltaX * i.settings.wheelSpeed;
            } else if (i.scrollbarYActive && !i.scrollbarXActive) {
                // only vertical scrollbar is active and useBothWheelAxes option is
                // active, so let's scroll vertical bar using both mouse wheel axes
                if (deltaY) {
                    element.scrollTop -= deltaY * i.settings.wheelSpeed;
                } else {
                    element.scrollTop += deltaX * i.settings.wheelSpeed;
                }
                shouldPrevent = true;
            } else if (i.scrollbarXActive && !i.scrollbarYActive) {
                // useBothWheelAxes and only horizontal bar is active, so use both
                // wheel axes for horizontal bar
                if (deltaX) {
                    element.scrollLeft += deltaX * i.settings.wheelSpeed;
                } else {
                    element.scrollLeft -= deltaY * i.settings.wheelSpeed;
                }
                shouldPrevent = true;
            }

            updateGeometry(i);

            shouldPrevent = shouldPrevent || shouldPreventDefault(deltaX, deltaY);
            if (shouldPrevent && !e.ctrlKey) {
                e.stopPropagation();
                e.preventDefault();
            }
        }

        if (typeof window.onwheel !== 'undefined') {
            i.event.bind(element, 'wheel', mousewheelHandler);
        } else if (typeof window.onmousewheel !== 'undefined') {
            i.event.bind(element, 'mousewheel', mousewheelHandler);
        }
    }

    function touch(i) {
        if (!env.supportsTouch && !env.supportsIePointer) {
            return;
        }

        var element = i.element;

        function shouldPrevent(deltaX, deltaY) {
            var scrollTop = Math.floor(element.scrollTop);
            var scrollLeft = element.scrollLeft;
            var magnitudeX = Math.abs(deltaX);
            var magnitudeY = Math.abs(deltaY);

            if (magnitudeY > magnitudeX) {
                // user is perhaps trying to swipe up/down the page

                if (
                    (deltaY < 0 && scrollTop === i.contentHeight - i.containerHeight) ||
                    (deltaY > 0 && scrollTop === 0)
                ) {
                    // set prevent for mobile Chrome refresh
                    return window.scrollY === 0 && deltaY > 0 && env.isChrome;
                }
            } else if (magnitudeX > magnitudeY) {
                // user is perhaps trying to swipe left/right across the page

                if (
                    (deltaX < 0 && scrollLeft === i.contentWidth - i.containerWidth) ||
                    (deltaX > 0 && scrollLeft === 0)
                ) {
                    return true;
                }
            }

            return true;
        }

        function applyTouchMove(differenceX, differenceY) {
            element.scrollTop -= differenceY;
            element.scrollLeft -= differenceX;

            updateGeometry(i);
        }

        var startOffset = {};
        var startTime = 0;
        var speed = {};
        var easingLoop = null;

        function getTouch(e) {
            if (e.targetTouches) {
                return e.targetTouches[0];
            } else {
                // Maybe IE pointer
                return e;
            }
        }

        function shouldHandle(e) {
            if (e.pointerType && e.pointerType === 'pen' && e.buttons === 0) {
                return false;
            }
            if (e.targetTouches && e.targetTouches.length === 1) {
                return true;
            }
            if (
                e.pointerType &&
                e.pointerType !== 'mouse' &&
                e.pointerType !== e.MSPOINTER_TYPE_MOUSE
            ) {
                return true;
            }
            return false;
        }

        function touchStart(e) {
            if (!shouldHandle(e)) {
                return;
            }

            var touch = getTouch(e);

            startOffset.pageX = touch.pageX;
            startOffset.pageY = touch.pageY;

            startTime = new Date().getTime();

            if (easingLoop !== null) {
                clearInterval(easingLoop);
            }
        }

        function shouldBeConsumedByChild(target, deltaX, deltaY) {
            if (!element.contains(target)) {
                return false;
            }

            var cursor = target;

            while (cursor && cursor !== element) {
                if (cursor.classList.contains(cls.element.consuming)) {
                    return true;
                }

                var style = get(cursor);

                // if deltaY && vertical scrollable
                if (deltaY && style.overflowY.match(/(scroll|auto)/)) {
                    var maxScrollTop = cursor.scrollHeight - cursor.clientHeight;
                    if (maxScrollTop > 0) {
                        if (
                            (cursor.scrollTop > 0 && deltaY < 0) ||
                            (cursor.scrollTop < maxScrollTop && deltaY > 0)
                        ) {
                            return true;
                        }
                    }
                }
                // if deltaX && horizontal scrollable
                if (deltaX && style.overflowX.match(/(scroll|auto)/)) {
                    var maxScrollLeft = cursor.scrollWidth - cursor.clientWidth;
                    if (maxScrollLeft > 0) {
                        if (
                            (cursor.scrollLeft > 0 && deltaX < 0) ||
                            (cursor.scrollLeft < maxScrollLeft && deltaX > 0)
                        ) {
                            return true;
                        }
                    }
                }

                cursor = cursor.parentNode;
            }

            return false;
        }

        function touchMove(e) {
            if (shouldHandle(e)) {
                var touch = getTouch(e);

                var currentOffset = { pageX: touch.pageX, pageY: touch.pageY };

                var differenceX = currentOffset.pageX - startOffset.pageX;
                var differenceY = currentOffset.pageY - startOffset.pageY;

                if (shouldBeConsumedByChild(e.target, differenceX, differenceY)) {
                    return;
                }

                applyTouchMove(differenceX, differenceY);
                startOffset = currentOffset;

                var currentTime = new Date().getTime();

                var timeGap = currentTime - startTime;
                if (timeGap > 0) {
                    speed.x = differenceX / timeGap;
                    speed.y = differenceY / timeGap;
                    startTime = currentTime;
                }

                if (shouldPrevent(differenceX, differenceY)) {
                    e.preventDefault();
                }
            }
        }
        function touchEnd() {
            if (i.settings.swipeEasing) {
                clearInterval(easingLoop);
                easingLoop = setInterval(function() {
                    if (i.isInitialized) {
                        clearInterval(easingLoop);
                        return;
                    }

                    if (!speed.x && !speed.y) {
                        clearInterval(easingLoop);
                        return;
                    }

                    if (Math.abs(speed.x) < 0.01 && Math.abs(speed.y) < 0.01) {
                        clearInterval(easingLoop);
                        return;
                    }

                    if (!i.element) {
                        clearInterval(easingLoop);
                        return;
                    }

                    applyTouchMove(speed.x * 30, speed.y * 30);

                    speed.x *= 0.8;
                    speed.y *= 0.8;
                }, 10);
            }
        }

        if (env.supportsTouch) {
            i.event.bind(element, 'touchstart', touchStart);
            i.event.bind(element, 'touchmove', touchMove);
            i.event.bind(element, 'touchend', touchEnd);
        } else if (env.supportsIePointer) {
            if (window.PointerEvent) {
                i.event.bind(element, 'pointerdown', touchStart);
                i.event.bind(element, 'pointermove', touchMove);
                i.event.bind(element, 'pointerup', touchEnd);
            } else if (window.MSPointerEvent) {
                i.event.bind(element, 'MSPointerDown', touchStart);
                i.event.bind(element, 'MSPointerMove', touchMove);
                i.event.bind(element, 'MSPointerUp', touchEnd);
            }
        }
    }

    var defaultSettings = function () { return ({
        handlers: ['click-rail', 'drag-thumb', 'keyboard', 'wheel', 'touch'],
        maxScrollbarLength: null,
        minScrollbarLength: null,
        scrollingThreshold: 1000,
        scrollXMarginOffset: 0,
        scrollYMarginOffset: 0,
        suppressScrollX: false,
        suppressScrollY: false,
        swipeEasing: true,
        useBothWheelAxes: false,
        wheelPropagation: true,
        wheelSpeed: 1,
    }); };

    var handlers = {
        'click-rail': clickRail,
        'drag-thumb': dragThumb,
        keyboard: keyboard,
        wheel: wheel,
        touch: touch,
    };

    var PerfectScrollbar = function PerfectScrollbar(element, userSettings) {
        var this$1 = this;
        if ( userSettings === void 0 ) userSettings = {};

        if (typeof element === 'string') {
            element = document.querySelector(element);
        }

        if (!element || !element.nodeName) {
            throw new Error('no element is specified to initialize PerfectScrollbar');
        }

        this.element = element;

        element.classList.add(cls.main);

        this.settings = defaultSettings();
        for (var key in userSettings) {
            this.settings[key] = userSettings[key];
        }

        this.containerWidth = null;
        this.containerHeight = null;
        this.contentWidth = null;
        this.contentHeight = null;

        var focus = function () { return element.classList.add(cls.state.focus); };
        var blur = function () { return element.classList.remove(cls.state.focus); };

        this.isRtl = get(element).direction === 'rtl';
        if (this.isRtl === true) {
            element.classList.add(cls.rtl);
        }
        this.isNegativeScroll = (function () {
            var originalScrollLeft = element.scrollLeft;
            var result = null;
            element.scrollLeft = -1;
            result = element.scrollLeft < 0;
            element.scrollLeft = originalScrollLeft;
            return result;
        })();
        this.negativeScrollAdjustment = this.isNegativeScroll
            ? element.scrollWidth - element.clientWidth
            : 0;
        this.event = new EventManager();
        this.ownerDocument = element.ownerDocument || document;

        this.scrollbarXRail = div(cls.element.rail('x'));
        element.appendChild(this.scrollbarXRail);
        this.scrollbarX = div(cls.element.thumb('x'));
        this.scrollbarXRail.appendChild(this.scrollbarX);
        this.scrollbarX.setAttribute('tabindex', 0);
        this.event.bind(this.scrollbarX, 'focus', focus);
        this.event.bind(this.scrollbarX, 'blur', blur);
        this.scrollbarXActive = null;
        this.scrollbarXWidth = null;
        this.scrollbarXLeft = null;
        var railXStyle = get(this.scrollbarXRail);
        this.scrollbarXBottom = parseInt(railXStyle.bottom, 10);
        if (isNaN(this.scrollbarXBottom)) {
            this.isScrollbarXUsingBottom = false;
            this.scrollbarXTop = toInt(railXStyle.top);
        } else {
            this.isScrollbarXUsingBottom = true;
        }
        this.railBorderXWidth =
            toInt(railXStyle.borderLeftWidth) + toInt(railXStyle.borderRightWidth);
        // Set rail to display:block to calculate margins
        set(this.scrollbarXRail, { display: 'block' });
        this.railXMarginWidth =
            toInt(railXStyle.marginLeft) + toInt(railXStyle.marginRight);
        set(this.scrollbarXRail, { display: '' });
        this.railXWidth = null;
        this.railXRatio = null;

        this.scrollbarYRail = div(cls.element.rail('y'));
        element.appendChild(this.scrollbarYRail);
        this.scrollbarY = div(cls.element.thumb('y'));
        this.scrollbarYRail.appendChild(this.scrollbarY);
        this.scrollbarY.setAttribute('tabindex', 0);
        this.event.bind(this.scrollbarY, 'focus', focus);
        this.event.bind(this.scrollbarY, 'blur', blur);
        this.scrollbarYActive = null;
        this.scrollbarYHeight = null;
        this.scrollbarYTop = null;
        var railYStyle = get(this.scrollbarYRail);
        this.scrollbarYRight = parseInt(railYStyle.right, 10);
        if (isNaN(this.scrollbarYRight)) {
            this.isScrollbarYUsingRight = false;
            this.scrollbarYLeft = toInt(railYStyle.left);
        } else {
            this.isScrollbarYUsingRight = true;
        }
        this.scrollbarYOuterWidth = this.isRtl ? outerWidth(this.scrollbarY) : null;
        this.railBorderYWidth =
            toInt(railYStyle.borderTopWidth) + toInt(railYStyle.borderBottomWidth);
        set(this.scrollbarYRail, { display: 'block' });
        this.railYMarginHeight =
            toInt(railYStyle.marginTop) + toInt(railYStyle.marginBottom);
        set(this.scrollbarYRail, { display: '' });
        this.railYHeight = null;
        this.railYRatio = null;

        this.reach = {
            x:
                element.scrollLeft <= 0
                    ? 'start'
                    : element.scrollLeft >= this.contentWidth - this.containerWidth
                        ? 'end'
                        : null,
            y:
                element.scrollTop <= 0
                    ? 'start'
                    : element.scrollTop >= this.contentHeight - this.containerHeight
                        ? 'end'
                        : null,
        };

        this.isAlive = true;

        this.settings.handlers.forEach(function (handlerName) { return handlers[handlerName](this$1); });

        this.lastScrollTop = Math.floor(element.scrollTop); // for onScroll only
        this.lastScrollLeft = element.scrollLeft; // for onScroll only
        this.event.bind(this.element, 'scroll', function (e) { return this$1.onScroll(e); });
        updateGeometry(this);
    };

    PerfectScrollbar.prototype.update = function update () {
        if (!this.isAlive) {
            return;
        }

        // Recalcuate negative scrollLeft adjustment
        this.negativeScrollAdjustment = this.isNegativeScroll
            ? this.element.scrollWidth - this.element.clientWidth
            : 0;

        // Recalculate rail margins
        set(this.scrollbarXRail, { display: 'block' });
        set(this.scrollbarYRail, { display: 'block' });
        this.railXMarginWidth =
            toInt(get(this.scrollbarXRail).marginLeft) +
            toInt(get(this.scrollbarXRail).marginRight);
        this.railYMarginHeight =
            toInt(get(this.scrollbarYRail).marginTop) +
            toInt(get(this.scrollbarYRail).marginBottom);

        // Hide scrollbars not to affect scrollWidth and scrollHeight
        set(this.scrollbarXRail, { display: 'none' });
        set(this.scrollbarYRail, { display: 'none' });

        updateGeometry(this);

        processScrollDiff(this, 'top', 0, false, true);
        processScrollDiff(this, 'left', 0, false, true);

        set(this.scrollbarXRail, { display: '' });
        set(this.scrollbarYRail, { display: '' });
    };

    PerfectScrollbar.prototype.onScroll = function onScroll (e) {
        if (!this.isAlive) {
            return;
        }

        updateGeometry(this);
        processScrollDiff(this, 'top', this.element.scrollTop - this.lastScrollTop);
        processScrollDiff(
            this,
            'left',
            this.element.scrollLeft - this.lastScrollLeft
        );

        this.lastScrollTop = Math.floor(this.element.scrollTop);
        this.lastScrollLeft = this.element.scrollLeft;
    };

    PerfectScrollbar.prototype.destroy = function destroy () {
        if (!this.isAlive) {
            return;
        }

        this.event.unbindAll();
        remove(this.scrollbarX);
        remove(this.scrollbarY);
        remove(this.scrollbarXRail);
        remove(this.scrollbarYRail);
        this.removePsClasses();

        // unset elements
        this.element = null;
        this.scrollbarX = null;
        this.scrollbarY = null;
        this.scrollbarXRail = null;
        this.scrollbarYRail = null;

        this.isAlive = false;
    };

    PerfectScrollbar.prototype.removePsClasses = function removePsClasses () {
        this.element.className = this.element.className
            .split(' ')
            .filter(function (name) { return !name.match(/^ps([-_].+|)$/); })
            .join(' ');
    };

    return PerfectScrollbar;

})));
//# sourceMappingURL=perfect-scrollbar.js.map

; $.scrollbar_horizontal_without_bar_step = 100;

(function() {
    $.scrollbar = {
        defaults: {
            show_vertical: true,
            show_horizontal: false,
            visible_on: "hover", //"always", "auto"
            hide_after: 8000,
            use_bar: true,
            reduce_margin_from_offset: false,
            add_padding_with_offset: true,
            vertical: {
                position: "right",
                offset: undefined,
                top_offset: 5,
                right_offset: 5,
                left_offset: undefined,
                add_margin_with_height: false,
                reduce_padding_from_height: false
            },
            horizontal: {
                position: "bottom",
                offset: undefined,
                top_offset: undefined,
                bottom_offset: 5,
                left_offset: 5,
                add_margin_with_width: false,
                reduce_padding_from_width: true,
                width: -10,
                snap_to_child_width: false // card tracks: step whole card+gap slots, not the bare track width
            },
            swipe_scroll: false
        },
    }
    $.tablescrollbar = {
        defaults: {
            use_parent_as_wrapper: true
        }
    }

    function _vPosition() {
        var height = this.configs.vertical.add_margin_with_height ? this.elm.outerHeight(true) : (this.configs.vertical.reduce_padding_from_height ? this.elm.height() : this.elm.innerHeight())
        this.v_bar.height(height)
        var signFix = function (dir, plus, min) {
            var offset = this["v_" + dir + "_offset"]
            if(offset > 0) {
                return plus + offset
            } else {
                return min + (-1 * offset)
            }
        }
        var left = signFix("left", "+", "-")
        var top = signFix("top", "+", "-")
        var right = signFix("right", "-", "+")
        switch (this.configs.vertical.position) {
            case "left":
                this.v_bar.position({
                    my: "left top",
                    at: "left" + left + " top" + top,
                    of: this.elm
                });
                break;
            case "right":
                bm.posRefChangeLtoR(this.v_bar.position({
                    my: "right top",
                    at: "right" + right + " top" + top,
                    of: this.elm
                }))
                break;
        }
    }

    function _hPosition() {
        var width = this.configs.horizontal.add_margin_with_width ? this.elm.outerWidth(true) : (this.configs.horizontal.reduce_padding_from_width ? this.elm.width() : this.elm.innerWidth())
        if(this.configs.horizontal.width) {
            width += this.configs.horizontal.width
        }
        this.v_bar.width(width)
        var signFix = function(dir, plus, min) {
            var offset = this["v_" + dir + "_offset"]
            if(offset > 0) {
                return plus + offset
            } else {
                return min + (-1 * offset)
            }
        }
        var left = signFix("left", "+", "-")
        var bottom = signFix("bottom", "-", "+")
        switch (this.configs.horizontal.position) {
            case "bottom":
                this.h_bar.position({
                    my: "bottom left",
                    at: "bottom" + bottom + " left" + left,
                    of: this.elm
                });
                break;
        }
    }

    function _vRender() {
        this.elm.addClass("vertical-scroll").css("overflow-y", "hidden")
        var bar = this.v_bar = "<div class='vertical scrollbar'></div>".jqObject.css('position', 'absolute').hide();
        var handler = this.v_handler = "<div class='scrollbar-handle'></div>".jqObject;
        bar.append(handler);
        this.elm.after(bar);
        if(bar.css("position") == "static") {
            bar.css("position", "absolute")
        }
        if(this.configs.vertical.position != "auto") {
            _vPosition.call(this);
        }
    }

    function _hRender() {
        this.elm.addClass("horizontal-scroll").css("overflow-x", "hidden")
        var bar = this.h_bar = "<div class='horizontal scrollbar'></div>".jqObject.css('position', 'absolute').hide();
        var handler = this.h_handler = "<div class='scrollbar-handle'></div>".jqObject;
        bar.append(handler);
        this.elm.after(bar);
        if(this.configs.horizontal.position != "auto") {
            _hPosition.call(this);
        }
    }

    function _vBarUpdate() {
        if (this.ready_for_show) {
            var containerHeight = this.elm.innerHeight();
            var requiredHeight = this.elm[0].scrollHeight;
            if(this.configs.visible_on == "always" || containerHeight < requiredHeight) {
                if(this.v_bar_shown) {
                    _vPosition.call(this);
                } else {
                    showBar.call(this, true, false);
                }
                if(this.v_bar_shown) {
                    if(this.mouse_on_v || this.v_dragging) {
                        clearTimer.call(this, true, false)
                    } else {
                        resetTimer.call(this, true, false);
                    }
                }
                var barInnerHeight = this.v_bar.innerHeight();
                var handlerHeight = containerHeight / requiredHeight * barInnerHeight;
                this.v_handler.css("height", bm.innerHeight(this.v_handler, handlerHeight, true));
                var scrollTop = this.elm.scrollTop()
                var handlerTop = scrollTop / requiredHeight * barInnerHeight;
                this.v_handler.css("top", handlerTop);
            } else {
                if(this.v_bar_shown) {
                    hideBar.call(this, true, false, true);
                }
            }
        } else {
            if(this.v_bar_shown) {
                _vPosition.call(this);
            }
        }
    }

    var isVerticalScrollEnable = false;
    var isHorizontalScrollEnable = false;

    function _hNavigatorUpdate() {
        if(this.configs.visible_on == "auto") {
            var containerWidth = this.elm.innerWidth();
            var requiredWidth = this.elm[0].scrollWidth;

            var containerHeight = this.elm.innerHeight();
            var requiredHeight = this.elm[0].scrollHeight;

            if(containerHeight < requiredHeight && containerWidth < containerHeight) {
                isVerticalScrollEnable = true;
            }
            else {
                isVerticalScrollEnable  = false;
            }

            if(containerWidth < requiredWidth && containerWidth > containerHeight) {
                isHorizontalScrollEnable = true;
            }
            else {
                isHorizontalScrollEnable  = false;
            }

            if (isHorizontalScrollEnable || isVerticalScrollEnable) {

                if (this.configs.horizontal.handle.left.is(":hidden")) {
                    this.elm.addClass("content-overflow")
                    this.configs.horizontal.handle.left.show();
                    this.configs.horizontal.handle.right.show();
                }
            } else {
                if (this.configs.horizontal.handle.left.is(":visible")) {
                    this.elm.removeClass("content-overflow")
                    this.configs.horizontal.handle.left.hide();
                    this.configs.horizontal.handle.right.hide();
                }
            }
        }
    }

    function _hBarUpdate() {
        if (this.ready_for_show) {
            var containerWidth = this.elm.innerWidth();
            var requiredWidth = this.elm[0].scrollWidth;
            if(this.configs.visible_on == "always" || containerWidth < requiredWidth) {
                if(this.h_bar_shown) {
                    _hPosition.call(this);
                } else {
                    showBar.call(this, false, true);
                }
                if(this.h_bar_shown) {
                    if(this.mouse_on_h || this.h_dragging) {
                        clearTimer.call(this, false, true)
                    } else {
                        resetTimer.call(this, false, true);
                    }
                }
                var barInnerWidth = this.h_bar.innerWidth();
                var handlerWidth = containerWidth / requiredWidth * barInnerWidth;
                this.h_handler.css("width", bm.innerWidth(this.h_handler, handlerWidth, true));
                var scrollTop = this.elm.scrollTop()
                var handlerTop = scrollTop / requiredWidth * barInnerWidth;
                this.h_handler.css("top", handlerTop);
            } else {
                if(this.h_bar_shown) {
                    hideBar.call(this, true, false, true);
                }
            }
        } else {
            if(this.h_bar_shown) {
                _hPosition.call(this);
            }
        }
    }

    function _hBarEvents() {
        var _self = this;
        var has_capture_support = this.elm[0].setCapture
        this.elm.mousemove(function(ev) {
            var scrollerOffset = _self.elm.offset().top;
            if (_self.configs.horizontal.position == "bottom") {
                scrollerOffset += _self.elm.height() - _self.h_bar.css("bottom").int()
            } else {
                scrollerOffset += _self.h_bar.css("top").int()
            }
            var mouseY = ev.pageY;
            if (Math.abs(scrollerOffset - mouseY) < 100) {
                _self.h_bar_in_area = true
                clearTimer.call(_self, false, true)
                if (!_self.h_bar_shown) {
                    _hBarUpdate.call(_self, true)
                }
            } else {
                _self.h_bar_in_area = false
                if (!_self.h_hide_timer && _self.h_bar_shown && !_self.h_dragging) {
                    resetTimer.call(_self, false, true)
                }
            }
        })
        this.h_bar.hover(function () {
            _self.mouse_on_h = true;
        }, function () {
            _self.mouse_on_h = false;
        });
        var initial_mouse_x
        var initial_handler_left
        var handler_container_width_ratio
        var handler_width
        var bar_width
        var mouseupHandler = function (ev) {
            _self.h_dragging = false;
            if (has_capture_support) {
                ev.target.releaseCapture()
            } else {
                document.removeEventListener("mouseup", mouseupHandler, true)
                document.removeEventListener("mousemove", mousemoveHandler, true)
            }
            if (!_self.h_bar_in_area) {
                hideBar.call(_self, false, true, true);
            }
        }
        var mousemoveHandler = function (ev) {
            if (_self.h_dragging) {
                bm.clearTextSelection()
                var x_diff = ev.pageX - initial_mouse_x
                var currentLeft = initial_handler_left + x_diff
                if (currentLeft < 0) {
                    initial_mouse_x = ev.pageX
                    initial_handler_left = 0
                }
                if (currentLeft + handler_width > bar_width) {
                    initial_mouse_x = ev.pageX
                    initial_handler_left = bar_width - handler_width
                }
                var handlerLeft = Math.round(currentLeft * handler_container_width_ratio);
                _self.elm.scrollLeft(handlerLeft);
                _self.update();
            }
        }
        this.h_handler.mousedown(function (ev) {
            initial_mouse_x = ev.pageX
            initial_handler_left = _self.h_handler.position().left
            bar_width = _self.h_bar.innerWidth()
            handler_container_width_ratio = _self.elm[0].scrollWidth / bar_width
            if (has_capture_support) {
                ev.target.setCapture()
            } else {
                document.addEventListener("mouseup", mouseupHandler, true)
                document.addEventListener("mousemove", mousemoveHandler, true)
            }
            _self.h_dragging = true;
            handler_width = _self.h_handler.outerWidth()
        })
        if (has_capture_support) {
            this.h_handler.mouseup(mouseupHandler).mousemove(mousemoveHandler)
        }
    }

    function getScrollStepValue(_self) {
        var step = _self.configs.horizontal.step || $.scrollbar_horizontal_without_bar_step;
        step = step == "auto" ? _self.elm.width() : $.scrollbar_horizontal_without_bar_step;
        return step;
    }

    // Card-boundary geometry from the LIVE DOM. The old version multiplied ONE measured
    // "slot" (first card outerWidth + column-gap) — but card widths are calc((100% -
    // gaps)/N) sub-pixel values, and the legacy (inline-block + margins) and flex
    // (column-gap) layout models pitch differently, so the tiny per-slot error compounded
    // every click into the cut-off drift (HWC-3344). Each card's offsetLeft is the ground
    // truth all of that bakes into, so targets are absolute card positions — nothing is
    // multiplied, nothing drifts.
    function getCardSlotGeometry(_self) {
        var track = _self.elm[0];
        var origin = null;
        var starts = [];
        var firstWidth = 0;
        _self.elm.children().each(function() {
            var child = $(this);
            if (child.is("script, style, link")) {
                return;
            }
            if (!child.outerWidth()) {
                return;
            }
            // offsetLeft is relative to the offsetParent — normalize to the FIRST card so
            // track padding/borders cancel out (scrollLeft 0 shows the first card at rest).
            if (origin === null) {
                origin = this.offsetLeft;
                firstWidth = child.outerWidth(true);
            }
            starts.push(this.offsetLeft - origin);
        });
        if (!starts.length) {
            return null;
        }
        // Page size = how many cards FULLY fit the viewport. The start-to-start pitch
        // already contains margins AND column-gap (whichever model the view uses); the
        // trailing (pitch - width) is the gap after the last visible card and the 2px
        // absorbs sub-pixel rounding of the calc() card width.
        var pitch = starts.length > 1 ? (starts[1] - starts[0]) : firstWidth;
        var cardsPerView = pitch > 0
            ? Math.max(1, Math.floor((track.clientWidth + (pitch - firstWidth) + 2) / pitch))
            : 1;
        return {
            starts: starts,
            cards_per_view: cardsPerView,
            max_scroll: Math.max(0, track.scrollWidth - track.clientWidth)
        };
    }

    // Move a WHOLE page of cards so a click always lands exactly on a card boundary:
    // 1 visible card pages by 1, 2-3 visible cards page by 2-3. The current card is the
    // NEAREST card start to the live scroll position (self-correcting after a clamped
    // animation, viewport rotation or manual drag), and the target never starts past the
    // last full page, so the final page sits flush with the end instead of showing a
    // cut-off sliver. Opt-in via horizontal.snap_to_child_width because step:"auto" is
    // shared with non-card scrollers.
    function scrollByCardSlots(_self, direction) {
        var geometry = getCardSlotGeometry(_self);
        if (!geometry) {
            return false;
        }
        var scrollLeft = _self.elm.scrollLeft();
        var current = 0;
        var bestDistance = Infinity;
        for (var i = 0; i < geometry.starts.length; i++) {
            var distance = Math.abs(geometry.starts[i] - scrollLeft);
            if (distance < bestDistance) {
                bestDistance = distance;
                current = i;
            }
        }
        var lastPageStart = Math.max(0, geometry.starts.length - geometry.cards_per_view);
        var target = Math.min(Math.max(current + direction * geometry.cards_per_view, 0), lastPageStart);
        _self.elm.animate({scrollLeft: Math.min(geometry.starts[target], geometry.max_scroll)});
        return true;
    }

    function getScrollCustomStepValue(_self) {
        var custom_step = _self.configs.horizontal.custom_step || $.scrollbar_horizontal_without_bar_step;
        custom_step = custom_step == "auto" ? _self.elm.width() : +custom_step;
        custom_step = isNaN(custom_step) ? $.scrollbar_horizontal_without_bar_step : custom_step;
        return custom_step;
    }

    function _hEvents() {
        var _self = this;
        if (this.configs.use_bar) {
            _hBarEvents.call(this)
        } else {
            if (_self.elm && _self.elm.children() !== "" && _self.elm.children().length > 0){
                var content = _self.elm.nat;
                var cardWidth = _self.elm.children()[0].offsetWidth;
                var cardWidthSnd
                if(_self.elm.children().length > 1) {
                    cardWidthSnd =   _self.elm.children()[1].offsetWidth;
                }
                if(cardWidth == 0 && cardWidthSnd > 0){
                    cardWidth = cardWidthSnd;
                }
                const cards = [];
                content.children.jqObject.each(function() {
                    if(!this.jqObject.is("script")) {
                        cards.push(this);
                    }
                })
                let cardPerView = Math.round(content.offsetWidth / cardWidth);
                if(cards.length < cardPerView){
                    content.jqObject.parent().find(".scroller").hide();
                }
            }
            var step = 0;
            this.configs.horizontal.handle.left.click(function() {
                if (_self.configs.horizontal.snap_to_child_width && scrollByCardSlots(_self, -1)) {
                    return;
                }
                step = _self.configs.horizontal.custom_step ? getScrollCustomStepValue(_self) : getScrollStepValue(_self)
                if(!_self.elm.is(".content") && isVerticalScrollEnable){
                    _self.elm.animate({scrollTop: "-=" + step});
                }
                else {
                    _self.elm.animate({scrollLeft: "-=" + step});
                }

            });
            this.configs.horizontal.handle.right.click(function() {
                if (_self.configs.horizontal.snap_to_child_width && scrollByCardSlots(_self, 1)) {
                    return;
                }
                step = _self.configs.horizontal.custom_step ? getScrollCustomStepValue(_self) : getScrollStepValue(_self)
                if(!_self.elm.is(".content") && isVerticalScrollEnable) {
                    _self.elm.animate({scrollTop: "+=" + step});
                }
                else {
                    _self.elm.animate({scrollLeft: "+=" + step});
                }
            });
        }
    }

    function _vEvents() {
        var _self = this;
        var has_capture_support = this.elm[0].setCapture
        this.elm.bind("mousewheel.scrollbar", function(ev) {
            var container = _self.elm
            var scrollTop = container.scrollTop()
            var scrollHeight = container[0].scrollHeight
            var innerHeight = container.innerHeight();
            if ((scrollTop == 0 && ev.deltaY > 0) || (ev.deltaY < 0 && scrollTop + innerHeight == scrollHeight)) {
                return true
            }
            var to_be_scroll = scrollTop - ev.deltaY * ev.deltaFactor
            container.scrollTop(to_be_scroll).trigger('vscroll');
            _self.update();
            return false
        });
        this.v_bar.hover(function() {
            _self.mouse_on_v = true;
        }, function() {
            _self.mouse_on_v = false;
        });
        var initial_mouse_y
        var initial_handler_top
        var handler_container_height_ratio
        var handler_height
        var bar_height
        var mouseupHandler = function (ev) {
            _self.v_dragging = false;
            if(has_capture_support) {
                ev.target.releaseCapture()
            } else {
                document.removeEventListener("mouseup", mouseupHandler, true)
                document.removeEventListener("mousemove", mousemoveHandler, true)
            }
            if (!_self.mouse_on_v) {
                resetTimer.call(_self, true, false)
            }
        }
        var mousemoveHandler = function(ev) {
            if(_self.v_dragging) {
                bm.clearTextSelection()
                var y_diff = ev.pageY - initial_mouse_y
                var currentTop = initial_handler_top + y_diff
                if(currentTop < 0) {
                    initial_mouse_y = ev.pageY
                    initial_handler_top = 0
                }
                if(currentTop + handler_height > bar_height) {
                    initial_mouse_y = ev.pageY
                    initial_handler_top = bar_height - handler_height
                }
                var handlerTop = Math.round(currentTop * handler_container_height_ratio);
                _self.elm.scrollTop(handlerTop);
                _self.update();
            }
        }
        this.v_handler.mousedown(function(ev) {
            initial_mouse_y = ev.pageY
            initial_handler_top = _self.v_handler.position().top
            bar_height = _self.v_bar.innerHeight()
            handler_container_height_ratio = _self.elm[0].scrollHeight / bar_height
            if(has_capture_support) {
                ev.target.setCapture()
            } else {
                document.addEventListener("mouseup", mouseupHandler, true)
                document.addEventListener("mousemove", mousemoveHandler, true)
            }
            _self.v_dragging = true;
            handler_height = _self.v_handler.outerHeight()
        })
        if(has_capture_support) {
            this.v_handler.mouseup(mouseupHandler).mousemove(mousemoveHandler)
        }
    }

    function swipeEvents() {
        var _self = this;
        if(!$.fn.swipe) {
            return
        }
        _self.elm.swipe({
            swipe: function(event, direction) {
                if(_self.configs.show_horizontal && (direction == "left" || direction == "right")) {
                    var step = _self.configs.horizontal.step || $.scrollbar_horizontal_without_bar_step
                    step = step == "auto" ? _self.elm.width() : $.scrollbar_horizontal_without_bar_step;
                    if(direction == "right") {
                        _self.elm.animate({scrollLeft: "-=" + step});
                    } else {
                        _self.elm.animate({scrollLeft: "+=" + step});
                    }
                }
                if(_self.configs.show_vertical &&  (direction == "up" || direction == "down")) {
                    var delta = direction == "up" ? 1 : -1;
                    var scrollTop = _self.elm.scrollTop();
                    _self.elm.scrollTop(scrollTop - delta * 40);
                    this.ready_for_show = true
                    _self.update();
                    return false;
                }
            },
            threshold: 30
        });
    }

    window.Scrollbar = function(container, settings) {
        this.elm = container instanceof $ ? container : $(container);
        this.configs = $.extend(true, {}, $.scrollbar.defaults, settings);
        this.init();
        this.render();
        this.bindEvents();
        this.ready_for_show = this.configs.visible_on == "always" || this.configs.visible_on == "auto"
        this.update();
    };

    var _s = Scrollbar.prototype;

    _s.init = function() {
        this.elm.addClass("scrollable");
        var ribArgs = this.configs.reduce_margin_from_offset ? {margin: true, border: true, padding:false} : {margin: false, border: false, padding: this.configs.add_padding_with_offset}
        var rib = this.configs.reduce_margin_from_offset ? {
            left: -1 * this.elm.leftRib(ribArgs.margin, ribArgs.border, ribArgs.padding),
            top: -1 * this.elm.topRib(ribArgs.margin, ribArgs.border, ribArgs.padding),
            right: -1 * this.elm.rightRib(ribArgs.margin, ribArgs.border, ribArgs.padding),
            bottom: -1 * this.elm.bottomRib(ribArgs.margin, ribArgs.border, ribArgs.padding)
        } : {
            left: this.elm.leftRib(ribArgs.margin, ribArgs.border, ribArgs.padding),
            top: this.elm.topRib(ribArgs.margin, ribArgs.border, ribArgs.padding),
            right: this.elm.rightRib(ribArgs.margin, ribArgs.border, ribArgs.padding),
            bottom: this.elm.bottomRib(ribArgs.margin, ribArgs.border, ribArgs.padding)
        }
        this.v_top_offset = (this.configs.vertical.offset == null ? this.configs.vertical.top_offset : this.configs.vertical.offset) + rib.top
        this.v_right_offset = (this.configs.vertical.offset == null ? this.configs.vertical.right_offset : this.configs.vertical.offset) + rib.right
        this.v_left_offset = (this.configs.vertical.offset == null ? this.configs.vertical.left_offset : this.configs.vertical.offset) + rib.left
        this.h_top_offset = (this.configs.horizontal.offset == null ? this.configs.horizontal.top_offset : offset) + rib.top
        this.h_bottom_offset = (this.configs.horizontal.offset == null ? this.configs.horizontal.bottom_offset : offset) + rib.bottom
        this.h_left_offset = (this.configs.horizontal.offset == null ? this.configs.horizontal.left_offset : offset) + rib.left
    }

    _s.update = function() {
        if(this.configs.show_vertical) {
            if(this.configs.use_bar) {
                _vBarUpdate.call(this)
            }
        }
        if(this.configs.show_horizontal) {
            if(this.configs.use_bar) {
                _hBarUpdate.call(this, false)
            } else {
                _hNavigatorUpdate.call(this)
            }
        }
        return this;
    }

    _s.render = function () {
        if(this.configs.show_vertical) {
            if(this.configs.use_bar) {
                _vRender.call(this);
            }
        }
        if(this.configs.show_horizontal) {
            if(this.configs.use_bar) {
                _hRender.call(this);
            }
        }
        if(this.configs.swipe_scroll) {
            swipeEvents.call(this)
        }
    }

    _s.destroy = function() {
        if(this.h_hide_timer) {
            clearTimeout(this.h_hide_timer);
        }
        if(this.v_hide_timer) {
            clearTimeout(this.v_hide_timer);
        }
        this.elm.removeClass("scrollable vertical horizontal").off("hover").off("mousewheel.scrollbar")
        if (!this.elm.is(this.elm)) {
            this.elm.parent().unwrapInner()
        }
        if(this.v_bar) {
            this.v_bar.remove()
        }
        if(this.h_bar) {
            this.h_bar.remove()
        }
    }

    function showBar(v, h) {
        if(this.configs.show_vertical && v) {
            this.v_bar.stop(true, true).show()
            if(this.v_bar_shown) {
                _vPosition.call(this)
            }
            this.v_bar_shown = true;
        }
        if(this.configs.show_horizontal && h) {
            this.h_bar.stop(true, true).show()
            if(this.h_bar_shown) {
                _hPosition.call(this)
            }
            this.h_bar_shown = true;
        }
    }

    function clearTimer(v, h) {
        if(v && this.v_hide_timer) {
            clearTimeout(this.v_hide_timer);
            this.v_hide_timer = null;
            if(this.v_bar_shown) {
                showBar.call(this, v)
            }
        }
        if(h && this.h_hide_timer) {
            clearTimeout(this.h_hide_timer);
            this.h_hide_timer = null;
            if(this.h_bar_shown) {
                showBar.call(this, false, h)
            }
        }
    }

    function resetTimer(v, h) {
        clearTimer(v, h)
        if(v) {
            if(this.configs.hide_after) {
                showBar.call(this, v)
                this.v_hide_timer = setTimeout(function() {
                    this.v_hide_timer = null;
                    hideBar.call(this, true, false);
                }.bind(this), this.configs.hide_after);
            } else {
                hideBar.call(this, true, false);
            }
        }
        if(h) {
            if(this.configs.hide_after) {
                showBar.call(this, false, h)
                this.h_hide_timer = setTimeout(function() {
                    this.h_hide_timer = null;
                    hideBar.call(this, false, true);
                }.bind(this), this.configs.hide_after);
            } else {
                hideBar.call(this, false, true);
            }
        }
    }

    function hideBar(v, h, immediate) {
        if(!arguments.length) {
            v = h = true;
        }
        if(this.v_bar_shown && this.configs.show_vertical && v) {
            var anim = function () {
                this.v_bar_shown = false;
            }.bind(this)
            if(immediate) {
                this.v_bar.hide()
                anim()
            } else {
                this.v_bar.fadeOut(1500, anim);
            }
        }
        if(this.h_bar_shown && this.configs.show_horizontal && h) {
            var anim = function () {
                this.h_bar_shown = false;
            }.bind(this)
            if(immediate) {
                this.h_bar.hide()
                anim()
            } else {
                this.h_bar.fadeOut(1500, anim);
            }
        }
    }

    _s.bindEvents = function () {
        var _self = this;
        if(this.configs.visible_on == "hover") {
            this.elm.add((this.h_bar && this.v_bar) ? this.h_bar.add(this.v_bar) : (this.h_bar || this.v_bar)).hover(function () {
                this.ready_for_show = true
                clearTimer.call(this, true, true)
                setTimeout(function() {
                    this.update()
                }.bind(this), 0)
            }.bind(this), function () {
                if (!(this.v_dragging || this.h_dragging)) {
                    this.ready_for_show = false
                    setTimeout(function() {
                        if(!(this.mouse_on_v || this.mouse_on_h)) {
                            hideBar.call(this)
                        }
                    }.bind(this), 0)
                }
            }.bind(this));
        }
        if(this.configs.show_vertical) {
            _vEvents.call(this);
        }
        if(this.configs.show_horizontal) {
            _hEvents.call(this)
        }
        this.elm.find(".scrollbar").on("remove", function() {
            _self.destroy()
        })
    }

    var _super = Scrollbar.prototype;

    window.TableScroll = function(container, settings) {
        if(settings) {
            settings = $.extend({}, $.tablescrollbar.defaults, settings)
        }
        _super.constructor.call(this, container, settings);
    }

    TableScroll.inherit(Scrollbar);

    var _t = TableScroll.prototype;

    _t.init = function() {

        this.configs.show_horizontal = false; //we do not support horizontal scroll for table
        this.configs.show_vertical = false;

        this.container = this.elm.wrap("<div class='scrollable-table-wrapper'></div>").parent();
        var clonedRow = header.call(this);
        var false_header = this.false_header_row.closest(".scrollable-table-header-wrapper");
        this.container.before(false_header).css({marginTop: -1 * parseFloat(clonedRow.find("th:first").css("border-bottom-width"))});
        this.top_row_height = false_header.outerHeight();
        if(this.configs.vertical.height == "auto") {
            var height = this.container.parent().height();
            this.configs.vertical.height = height - this.top_row_height;
        } else {
            this.configs.vertical.height -= this.top_row_height;
        }

        this.container.scrollbar({
            show_vertical: true,
            vertical: {
                offset: 0,
                step: "auto",
            }
        })

    }

    _t.height = function(height) {
        _super.height.call(this, height - this.top_row_height);
    }

    _t.destroy = function() {
        _super.destroy.call(this)
        this.false_header_row.closest(".scrollable-table-header-wrapper").remove()
        var visibleTr = this.container.find("tr:has(th)");
        var originalTable = this.container.find("table").prepend(visibleTr.show());
        originalTable.parent().replaceWith(originalTable);
    }

    function header() {
        var visibleTr = this.container.find("tr:has(th)");
        var clonedRow = visibleTr.clone();
        visibleTr.copyDeepEvents(clonedRow, true);
        var falseHeader;
        var fakeTable;
        var originalTable = this.container.find("table");
        if(!this.false_header_row) {
            falseHeader = $("<div class='scrollable-table-header-wrapper'><table class='scrollable-table-header'></table></div>");
            fakeTable = falseHeader.find("table");
            originalTable.copyEvents(fakeTable, true);
        } else {
            fakeTable = this.false_header_row.closest("table");
        }
        fakeTable.html(this.container.find("colgroup").clone()).append(clonedRow);
        this.false_header_row = fakeTable.find("tr:first");
        visibleTr.hide()
        return clonedRow;
    }

    _t.content = function(toChange) {
        if(toChange) {
            var parents = toChange.parentsUntil("tr");
            var toReplace = this.false_header_row;
            if(parents.length) {
                parents.each(function() {
                    var index = $(this).index();
                    toReplace = toReplace.children().eq(index);
                })
            }
            var index = toChange.index();
            toReplace = toReplace.children().eq(index);
            var clonedTo = toChange.clone();
            toChange.copyDeepEvents(clonedTo, true)
            toReplace.replaceWith(clonedTo)
        } else {
            header.call(this);
            this.update();
        }
        return this.container.find("table");
    }

    _t.header = function() {
        return this.false_header_row;
    }
})()

bm.jquerify("scrollbar", Scrollbar);
bm.jquerify("tscrollbar", TableScroll);

if (bm && bm.ui_updaters) {
    bm.ui_updaters.push(function () {
        this.find(".scrollable").addBack(".scrollable").each(function() {
            var _this = this.jqObject
            var scrollbar = _this.scrollbar("inst")
            if (scrollbar) {
                scrollbar.update()
                return;
            }
            var config = _this.config("scrollable")
            if(_this.is("table")) {
                _this.tscrollbar(config)
            } else {
                _this.scrollbar(config)
            }
        })
    })
}